module.exports = __webpack_public_path__ + "img/the_cars.a2d77c12.png";